import { Button } from "@/components/ui/button";
import DiscordIcon from "@/assets/icons8-discord.svg?react";
import GithubIcon from "@/assets/icons8-github.svg?react";
import TwitterIcon from "@/assets/icons8-x.svg?react";

export function DiscordButton() {
  return (
    <a href="https://discord.gg/EefvxaKbbx" target="_blank">
      <Button size="icon" variant="ghost">
        <DiscordIcon title="Discord" />
      </Button>
    </a>
  );
}
export function TwitterButton() {
  return (
    <a href="https://x.com/Myth_Finance/" target="_blank">
      <Button size="icon" variant="ghost">
        <TwitterIcon />
      </Button>
    </a>
  );
}
export function GithubButton() {
  return (
    <a href="https://github.com/MythFinance/" target="_blank">
      <Button size="icon" variant="ghost">
        <GithubIcon />
      </Button>
    </a>
  );
}

export default function Footer() {
  return (
    <div className="w-full bg-card/25 backdrop-blur-md h-12 flex justify-end items-center px-4 gap-4 text-muted-foreground hover:text-foreground">
      <GithubButton />
      <TwitterButton />
      <DiscordButton />
    </div>
  );
}
